import React, { Component,createRef } from 'react'

import axios from 'axios';
import MyLoader from '../Spinner/MyLoader';
import SessionManager from '../Utils/SessionManager';
import {Link, Redirect } from 'react-router-dom'
import {Button, Modal} from 'react-bootstrap'
import '../css/Admin_css/admin-customize.css';
import COLORS from '../resources/colors/COLORS';
import myToast from '../Utils/MyToast';
import uploadIcon from '../resources/images/upload-icon.png'
import MdlSelectSession from './MdlSelectSession';


export default class MdlSelectReportCard extends Component {
    constructor(props){
        super(props)       
       
       
        const token=localStorage.getItem("token");
        let loggedIn=true;
        if(token==null){
          loggedIn=false;
        }
      
        this.state={   
            loggedIn:true,
            Loading:false, 
            LoadingStudent:false,
            isOpenSessionDialog:false,
            show:true,
            mExamReportCardList:[],
            CLASS_ID:'',
            SECTION_ID:'',
            REPORT_CARD_ID:'',
            REPORT_CARD_NAME:'',
          
      
            SESSION_ID:'',
            SESSION_NAME:'',
            SESSION_STATUS:'',
            SELECTED_POSITION:0
           
        }
      
}

ChangeSession = () => {
 
  this.HandleShowSessionDialog();
}

HandleShowSessionDialog = () => {
  this.setState({
    isOpenSessionDialog: !this.state.isOpenSessionDialog
  });   
}

HandleCloseSessionDialog = () => {

  this.setState({
    isOpenSessionDialog:false
  });  
   
}
HandleSelectedSession = (session_id,session_name,session_status) => {
  this.state.SESSION_ID=session_id;
  this.state.SESSION_NAME=session_name;
  this.state.SESSION_STATUS=session_status;
  this.setState({
    
    isOpenSessionDialog:false
  });
 
  this.getReportCardList();
}

HandleClose = () => {

  this.setState({
    show: !this.state.show
  });
this.props.action_close();
  
}
SelectReportCard = (reportcard_id,reportcard_name,position) => {
  //alert("okk"+student_id);
  
  this.setState({
    REPORT_CARD_ID:reportcard_id,
    REPORT_CARD_NAME:reportcard_name,
    SELECTED_POSITION:position
  })  
 // alert(this.state.REPORT_CARD_ID);
 // alert(this.state.REPORT_CARD_NAME);
}

HandleSelectedReportCard = () => {
  //alert("okk"+this.state.REPORT_CARD_ID);
  this.setState({
    show: !this.state.show
  });
  this.props.action_select(this.state.REPORT_CARD_ID,this.state.REPORT_CARD_NAME,this.state.SESSION_ID);
  
}

componentDidMount(){

  var mSession=SessionManager.getCurrentSession();
  this.state.SESSION_ID=mSession[0].session_id;
  this.state.SESSION_NAME=mSession[0].session_name;
  this.state.SESSION_STATUS=mSession[0].status;

 
  this.getReportCardList();
}    

getReportCardList(){

this.setState({
  Loading:true
})
const SCHOOL_CODE=SessionManager.getSchoolCode();
const FUNCTION_NAME='getSchoolRepordCardList.php'
URL=process.env.REACT_APP_SERVER_NAME+process.env.REACT_APP_TARGET_DIR+FUNCTION_NAME
console.log("URL>>>>>"+URL)
// var params = new URLSearchParams();
  //  params.append('school_code', SCHOOL_CODE);

axios.get(URL,{
  params:{
    school_code:SCHOOL_CODE,
    session_id:this.state.SESSION_ID,
  
  }
}).then(res => res.data)
.then((response) => {
 
  this.setState({ 
    Loading:false
   })
   // console.log("Response2>>>>>"+response);
    let api_status=response.api_status;
    //alert(JSON.stringify(response));
    
    if(api_status=="OK")
    {
    
       this.setState({       
            mExamReportCardList:response.data     
        })
        if(this.state.mExamReportCardList.length!==0)
        {
          this.state.REPORT_CARD_ID=this.state.mExamReportCardList[this.state.SELECTED_POSITION].report_card_id;
          this.state.REPORT_CARD_NAME=this.state.mExamReportCardList[this.state.SELECTED_POSITION].report_card_name;
          this.state.SESSION_ID=this.state.mExamReportCardList[this.state.SELECTED_POSITION].session_id;
        }
        
        //console.log("response>>>>>"+this.state.mClassData);
    }
    else{
      let api_remark=response.api_remark;
      myToast.notify_warning(api_remark);
    } 

  //console.log("response>>>>>"+api_status)
 }).catch((error)=>{
  this.setState({ 
    Loading:false
   })
  console.log("error>>>>>"+error);
  });
} 
getConcernedExam(item)
{
    var concernedExam="";
    var mExam=item.exams_list;
    if(mExam!==null && mExam.length!==0)
    {
      for (let index = 0; index < mExam.length; index++) {
          if(index==0)
          {
              concernedExam=mExam[index].exam_name;
          }
          else{
            concernedExam=concernedExam+','+mExam[index].exam_name;
          }
        
      }
    }
    return concernedExam;
   
}

    render() {
      
        if( this.state.loggedIn==false)
        {
        return <Redirect to='/Login'/>;
        }
       
        else{
            return (

              <div>
                
      <Modal show={this.state.show} onHide={this.HandleClose} animation={false} style={{opacity:1} }
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Select Progress Report
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {this.state.Loading ? <MyLoader/> : 
<>

            <div className="row">

            <div className="col-sm-12 col-md-12">
            <Link to='#' onClick={()=>this.ChangeSession()}>
            <p className="bg_card_blue" style={{padding:'1px 5px 1px 5px',fontSize:'18px', textAlign:'center',color:COLORS.white}}> Session:
              {this.state.SESSION_NAME+"("+ this.state.SESSION_STATUS+")"}
            <span style={{float:'right'}}> <img src={uploadIcon} alt="upload image" className="bg_card_blue" style={{height:'25px',width:'25px'}}/> </span> </p>                                    
            </Link>
            </div>  

            </div>

              <div className="row" style={{padding:'0px 15px 0px 15px'}}>
              {this.state.mExamReportCardList.map((item, index) => (
              <div className="col-sm-4 col-md-4" style={{padding:'0px 2px 5px 2px'}}>
                  <div className={this.state.SELECTED_POSITION===index?"bg_class_select2 gravity_center_vertical":"bg_class_deselect_grey2 gravity_center"} onClick={e=>this.SelectReportCard(item.report_card_id,item.report_card_name,index)} style={{cursor:'pointer'}}> 
                    <h3 style={{fontSize:14}}> {item.report_card_name} </h3>
                    <h5 style={{fontSize:14}}> {this.getConcernedExam(item)} </h5>
                  </div>
              </div>
              ))}
                </div>

  </>
      }
                       
      </Modal.Body>
      <Modal.Footer>
            <Button variant="primary" size="lg"  block onClick={this.HandleSelectedReportCard}>
                Done
            </Button>
          
          </Modal.Footer>
    </Modal>

    {this.state.isOpenSessionDialog===true? <MdlSelectSession action={this.HandleCloseSessionDialog} action2={this.HandleSelectedSession}></MdlSelectSession>:''}
           
            </div>
      
            )
        }
    }
}

